export const CN_RULE_FIELD_INPUT_TYPE_VALUES = {
    1: 'TEXT',
    2: 'SELECT',
    3: 'NUM_AUTO'
};

export const CN_RULE_FIELD_INPUT_TYPE = {
    TEXT: 1,
    SELECT: 2,
    NUM_AUTO: 3,
};
